export const getCookieByName = (name, cookie) => {
  const value = `; ${cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts
      .pop()
      .split(';')
      .shift()
  }

  return null
}
